import React from 'react';
export function Wordmark({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`flex items-baseline font-sans text-xl font-bold tracking-tightest text-ink ${className}`} data-id="element-170" data-mp="3txefylrfxtyj">
      VOID
      <span className="ml-[2px] font-normal text-ink" data-id="element-171" data-mp="2ka0yojaxt33">(∅)</span>
    </span>;
}